export default function NotFound() {
  return (
    <>
      <div className="Body">Page not found</div>
    </>
  );
}
